import { render, staticRenderFns } from "./StepCard.vue?vue&type=template&id=123906e5&scoped=true&"
import script from "./StepCard.vue?vue&type=script&lang=ts&"
export * from "./StepCard.vue?vue&type=script&lang=ts&"
import style0 from "./StepCard.vue?vue&type=style&index=0&id=123906e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123906e5",
  null
  
)

export default component.exports